<template>
  <div class="personal-details" redesign>
    <!-- Header -->
    <NomineeProgressBar v-if="employeeCode"
      :stepNumber=4
      :numberOfSteps=5
      stepName="Personal Details"
    />
    <NomineeProgressBar v-else
      :stepNumber=2
      :numberOfSteps=3
      stepName="Personal Details"
    />

    <div class="form-container personal-details-form">
      <LoadSpinner v-if="loading" :color="`#${organizationDetails.darkBrandColor}`" />
      <template v-if="!loading">
        <SurveyResponseComponent
          :surveyResponse="surveyResponse"
          :cleanSurvey="false"
          :buttonText="$gettext('Next')"
          @survey-done="handleSubmit"
          :darkText="true"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner } from '@/components'
import NomineeProgressBar from '@/components/stepper/NomineeProgressBar'
import SubmitButton from '@/components/requests/SubmitButton'
import SurveyResponseComponent from '@/components/SurveyResponse'

import NomineesApi from '@/services/nominees'
import SurveyResponse from '@/services/surveyresponses'
import StipendRequest from '@/services/stipendRequests'

export default {
  name: 'NomineeOnboardingPersonalDetails',
  components: {
    LoadSpinner,
    NomineeProgressBar,
    SurveyResponseComponent,
    SubmitButton,
  },
  data() {
    return {
      loading: true,
      employeeCode: null,
      surveyName: 'Nominee Personal Details',
      surveyResponse: null,
    }
  },
  async created() {
    this.employeeCode = this.$route.params.code
  },
  async mounted() {
    const stipendRequest = await NomineesApi.createOrGetStipendRequest({ program_month: 1 })
    await this.$store.dispatch('updateCurrentRequest', stipendRequest)

    // We found the current request, update our model

    if(stipendRequest.personalDetails)
      this.surveyResponse = await SurveyResponse.api.retrieve(stipendRequest.personalDetails)

    // If the survey response doesn't exist, then create one
    if(!this.surveyResponse) {
      this.surveyResponse = await SurveyResponse.getOrCreate(this.user, this.surveyName)

      // Update our current request w/ the survey reference & save the stipend request
      stipendRequest['personalDetails'] = this.surveyResponse.id
      this.$store.dispatch('updateCurrentRequest', stipendRequest)
      await NomineesApi.saveStipendRequest(stipendRequest)
    }

    // Start editing ping
    this.$store.dispatch('startEditingStipendRequestPing', stipendRequest)

    this.loading = false
  },
  unmounted() {
    this.$store.dispatch('stopEditingStipendRequestPing')
  },
  beforeRouteLeave(to, from,  next) {
    this.$store.dispatch('stopEditingStipendRequestPing')
    next()
  },
  methods: {
    handleSubmit() {
      StipendRequest.api.trackUpdate(this.currentRequest, StipendRequest.options.PERSONAL_DETAILS_UPDATED)
      this.$router.push({ name: 'NomineeOnboardingDocumentation', params: { code: this.employeeCode }, })
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars', 'currentRequest']),
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.personal-details {
  display: flex;
  flex-direction: column;

  .personal-details-form {
    @extend .constrain-tablet-and-up;

    @media (min-width: 1140px) {
      max-width: 1076px !important;
    }
  }
}
</style>
